<template>
    <div v-if="withButton">
        <b-form-group v-bind="$attrs">
            <b-button variant="primary" @click="editor.show = true"> {{ btnLabel }} </b-button>
        </b-form-group>

        <main-dialog :title="$attrs.label" size="xl" v-model="editor.show" hide-footer>
            <b-form-group 
                :description="editor_description"
            >
              <MonacoEditor 
                ref="editor"
                @input="onChange"
                :value="content" 
                :language="getLanguage()"
                :options="monacoOptions"
              />

                <small v-for="(error, index) in errors" :key="index">  {{ error }}  </small>
            </b-form-group>
            <slot></slot>
        </main-dialog>
    </div>
     <b-form-group 
        v-else
        :description="editor_description"
    >
        <MonacoEditor 
          ref="editor"
          @input="onChange"
          :value="content" 
          :language="getLanguage()"
          :options="monacoOptions"
        />

        <small v-for="(error, index) in errors" :key="index">  {{ error }}  </small>
    </b-form-group>
</template>

<style scoped>
.editor-controls {
    margin: 5px 0px 10px 0px;
    padding: 0;
    list-style: none;
}

.editor-controls > li {
    display: inline-block;
    margin: 0px 5px;
}

.line-error {
    background-color: red
}

.libs-editor-wrapper {
    height: 100px;
}

</style>

<script>
import MonacoEditor from '@/components/form/Editor/MonacoEditor.vue'

export default {
    components: {
        MonacoEditor
    },
    props: {
        value: {
            type: String
        },
        placeholder: {
            type: String
        },
        controls: {
            type: Array,
            default: function() {
                return ['*'];
            }
        },
        editor_description: {
            type: String
        },
        libs: {
            type: Array,
            default: function() {
                return []
            }
        },
        vars: {
            type: Array,
            default: function() {
                return []
            }
        },
        snippets: {
            type: Array,
            default: function() {
                return []
            }
        },
        lang: {
            type: String,
            default: 'text/html'
        },
        errors: {
            type: Array,
            default: function() {
                return []
            }
        },
        btnLabel: {
            type: String,
            default: 'Open editor'
        },
        withButton: {
            type: Boolean,
            default: true
        },
    },
    data : function() {
        return {
            loadEditor: false,
            editor: {
                show: false,
            },
            snippetSelected: ''
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        monacoOptions() {
            return {
                theme: this.$store ? (this.$store.getters.getCurrentTheme === 'light' ? 'vs' : 'vs-dark') : 'vs-dark',
                fontSize: 14,
                lineNumbers: 'on',
                automaticLayout: true,
                minimap: { enabled: false },
                scrollBeyondLastLine: false
            }
        }
    },
    methods: {
        getLanguage() {
            const langMap = {
                'text/html': 'html',
                'text/javascript': 'javascript',
                'application/json': 'json',
                'text/css': 'css'
            }
            return langMap[this.lang] || 'html'
        },

        controlActionsEvent(e, data) {
            this.$emit("controlAction", e, data);
        },

        onChange(code) {
            this.$emit("onInput", code);
        },
        
        platformTheme() {
            if (this.$store) {
                return this.$store.getters.getCurrentTheme == 'light' ? 'default' : 'material-palenight'
            }

            return 'material-palenight'
        }
    }
}
</script>